export const additionalSounds = [
    {
        src: "sounds/birthday_cake_sound.mp3",
        id: "birthday",
    },
];
